import { useEffect, useRef, useState } from "react";

// const SESSION_TIMEOUT = 60 * 1000; // test: 1 minute
// const WARNING_TIME = 30 * 1000; // warning after 30 sec

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const WARNING_TIME = 25 * 60 * 1000;    // Show warning after 25 minutes

export default function useSessionTimeout() {
    const isAuthPage =
        window.location.pathname.includes("/session/signin") ||
        window.location.pathname.includes("/session/signup") ||
        window.location.pathname.includes("/session/forgot-password");

    const hasToken = !!localStorage.getItem("accessToken");

    const [showWarning, setShowWarning] = useState(false);
    const [countdown, setCountdown] = useState(30);

    const warningTimerRef = useRef(null);
    const logoutTimerRef = useRef(null);
    const countdownTimerRef = useRef(null);
    const warningOpenRef = useRef(false);

    const logout = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/session/signin";
    };

    const clearTimers = () => {
        clearTimeout(warningTimerRef.current);
        clearTimeout(logoutTimerRef.current);
        clearInterval(countdownTimerRef.current);
    };

    const openWarning = () => {
        warningOpenRef.current = true;
        setShowWarning(true);
        setCountdown((SESSION_TIMEOUT - WARNING_TIME) / 1000);

        countdownTimerRef.current = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownTimerRef.current);
                    logout();
                    return 0;
                }

                return prev - 1;
            });
        }, 1000);
    };

    const startTimers = () => {
        clearTimers();

        warningOpenRef.current = false;
        setShowWarning(false);

        warningTimerRef.current = setTimeout(openWarning, WARNING_TIME);

        logoutTimerRef.current = setTimeout(() => {
            logout();
        }, SESSION_TIMEOUT);
    };

    const handleActivity = () => {
        // Do not hide/reset warning when dialog is open
        if (warningOpenRef.current) return;

        startTimers();
    };

    const continueSession = () => {
        warningOpenRef.current = false;
        startTimers();
    };

    // useEffect(() => {

    //     // Do not use mousemove, it fires constantly and makes testing hard
    //     const events = ["keydown", "click", "scroll", "touchstart"];

    //     events.forEach((event) => {
    //         window.addEventListener(event, handleActivity);
    //     });

    //     startTimers();

    //     return () => {
    //         clearTimers();

    //         events.forEach((event) => {
    //             window.removeEventListener(event, handleActivity);
    //         });
    //     };
    // }, []);

    useEffect(() => {
        if (isAuthPage || !hasToken) {
            clearTimers();
            setShowWarning(false);
            warningOpenRef.current = false;
            return;
        }

        const events = ["keydown", "click", "scroll", "touchstart"];

        events.forEach((event) => {
            window.addEventListener(event, handleActivity);
        });

        startTimers();

        return () => {
            clearTimers();

            events.forEach((event) => {
                window.removeEventListener(event, handleActivity);
            });
        };
    }, [isAuthPage, hasToken]);

    return {
        showWarning,
        countdown,
        continueSession,
        logout,
    };
}